export default {
      id: "gb-sct-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#gb-sct",
      toString: function () {
        return this.url;
      }
    }